<div class="wrapper-impersonate" *ngIf="service.hasRights">
    <div class="impersonate" [ngClass]="{'active' : service.selected}">
        <div class="d-flex">
            <div class="">
                <div class="impersonate-header">
                    <span>Rolle</span>
                </div>
                <div *ngIf="!service.selected" class="wrapper-select">
                    <select class="form-select form-select-sm employee-list" [(ngModel)]="selectedEmployee" (ngModelChange)="select()">
                        <option value="" selected>Master</option>
                        <option value="{{employee['email']}}" *ngFor="let employee of service.employees| sortBy:sortByCol;let i = index">{{employee['level']}}</option>
                    </select>
                </div>
                <div *ngIf="service.selected" class="selected-name">
                    <span>{{service.selected['name']}}</span>
                </div>
                <div *ngIf="service.selected" class="selected-level">
                    <span >{{service.selected['level']}}</span>
                </div>
            </div>
            <div *ngIf="service.selected" class="">
                <button  class="btn btn-reset" (click)="reset()">
                    <span>reset</span>
                </button>
            </div>
        </div>
        
    </div>
</div>